import React from "react";
import { Link } from "react-router-dom";

/*Import UTILS */
import { renderHighlightedPath } from "../utils/renderHighlightedPath";

/* React-Bootstrap component */
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

/*React-icons */
import { BiLayerPlus } from "react-icons/bi";
import { AiOutlineEdit } from "react-icons/ai";

import RoleGuard from "../../auth/RoleGuard";
import { MODULES, ROLE_GROUPS } from "../../auth/roles";

const ProgramStructureContainerTreeItem = ({
  id,
  program,
  nivoK4,
  changeProgramStatus,
  searchQuery,
}) => {
  return (
    <>
      <Row>
        <Col lg={7} xl={9} className="d-flex align-items-center">
          <div
            className="program-structure-naslov__hover"
            id={program.objectID}
          >
            {renderHighlightedPath(program.naziv, searchQuery, 3)}
          </div>
          <div
            className={`programs-structure-card-aktiven-text ms-3 ${program.aktiven ? "card-text--activated" : "card-text--deactivated"}`}
            onClick={() => changeProgramStatus(program.objectID)}
          >
            {program.aktiven && <span> Aktiven </span>}
            {!program.aktiven && <span> Neaktiven </span>}
          </div>
        </Col>
        <Col lg={5} xl={3}>
          <RoleGuard moduleKey={MODULES.PROGRAMI} roles={ROLE_GROUPS.EDITORS}>
            <div className="float-end">
              <Link
                className="programs-button-add-text"
                to={`/Programi/UrediProgram/${program.objectID}`}
              >
                <Button variant="outline-primary">
                  <AiOutlineEdit />
                </Button>
              </Link>
              {!nivoK4 && (
                <Link
                  className="programs-button-add-text ms-2"
                  to={`/Programi/DodajProgram/${program.objectID}`}
                >
                  <Button variant="outline-primary">
                    <BiLayerPlus />
                  </Button>
                </Link>
              )}
            </div>
          </RoleGuard>
        </Col>
      </Row>
    </>
  );
};

export default ProgramStructureContainerTreeItem;
